export const Literals = {
    ALL: 'ALL'
}
